<template>
  <el-dialog
    custom-class="import-dialog"
    title="添加品牌"
    :visible="visible"
    width="800px"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="搜索品牌"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          stripe
          border
          ref="brandTable"
          @current-change="handleCurrentChange"
          highlight-current-row
          @selection-change="getChecked"
          :data="allBrandActivityList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="编号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            show-overflow-tooltip
            align="center"
            prop="brandLogo"
            label="品牌logo图"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.brandLogo"
                alt
                style="width:60px;height:60px"
                v-if="scope.row.brandLogo"
              />
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="是否显示"
            prop="isSalesEndDisplay"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.isSalesEndDisplay == 'true'" class="success"
                >显示</span
              >
              <span v-else class="danger">隐藏</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relationSpu"
            label="相关商品"
            sortable
          ></el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="allBrandActivityList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: mapGetters(["allBrandActivityList", "allBrandList"]),
  components: {},
  data() {
    return {
      sort: {},
      keyWords: '',
      currentRow: {},
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false
    };
  },
  watch: {
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    save() {
      if (!this.currentRow.brandId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        this.$emit("saveBrand", this.currentRow);
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        isWxshop: "yes",
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const actionName = queryAll
        ? "queryBrandAllList"
        : "queryBrandActivityList";
      return this.$store.dispatch(actionName, params);
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
